import React from 'react';
import PerformanceCompetencyCard from '../behaviours/components/performanceCompetencyCard';
import { DomHelpers } from 'e4shared';
import { ratingColour } from 'helpers/metrics';
import NoResults from 'components/general/noResults';
import { translate } from 'helpers/translations';
import { useSelector } from 'react-redux';

export const All = ({ profile, text, show, onFlag, data, loading, reloading, competencies, search }) => {
    const [filtered, setFiltered] = React.useState([]);
    const [areas, setAreas] = React.useState([]);
    const [drilldown, setDrilldown] = React.useState({});
    const { user } = useSelector(state => state.user);

    React.useEffect(() => {
        if (competencies?.length) {
            const temp = competencies.reduce((a, c) => {
                if (a.some(x => x.id === c.area_Id)) {
                    return a;
                } else {
                    return a.concat([
                        { id: c.area_Id, name: c.area, sequence: c.area_Sequence, translations: c.area_Translations },
                    ]);
                }
            }, []);

            setAreas(temp.sort((a, b) => (a.sequence ? b.sequence > 1 : -1)));
        }
    }, [competencies]);

    React.useEffect(() => {
        let temp = [...data];
        const stext = search.text?.toLowerCase();
        if (stext) {
            temp = temp.filter(x => x.full_Name.toLowerCase().indexOf(stext) >= 0);
        }

        if (search.filters?.competencies?.length) {
            const scompetencies = search.filters?.competencies;
            temp = temp.filter(x => scompetencies.some(s => s === x.id));
        }

        if (search.filters?.objectives?.length) {
            const sobjs = search.filters?.objectives;
            temp = temp.filter(x =>
                sobjs.some(s => (s === 'U' && x.upcoming_Tasks_Count) || (s === 'O' && x.overdue_Tasks_Count))
            );
        }

        if (search.filters?.score?.length) {
            const sscore = search.filters?.score;
            temp = temp.filter(x => sscore.some(s => s === x.rating));
        }

        if (search.filters?.flagged?.length) {
            const sflagged = search.filters?.flagged;
            temp = temp.filter(x => sflagged.some(s => s === x.flagged));
        }

        setFiltered(temp);
    }, [data, search]);

    React.useEffect(() => {
        const resizeHandler = () => DomHelpers.arrangeTiles('behaviour-sync');
        setTimeout(() => resizeHandler(), 250);
        window.addEventListener('resize', resizeHandler);

        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, [loading, drilldown, search]);

    return (
        <div key="all-competencies">
            {filtered.length > 0 ? (
                areas.map(area => {
                    area.name = translate(user.language_Code, area, 'Name');

                    const areaCompetencies = competencies.filter(c => c.area_Id === area.id);

                    const areaCompetenciesFiltered = areaCompetencies.filter(c => filtered.some(f => f.id === c.id));

                    const totalRating = areaCompetencies.reduce((a, c) => a + c.rating, 0);
                    const rating = totalRating / areaCompetencies.length;

                    if (!areaCompetenciesFiltered.length) return null;

                    return (
                        <div key={`area-${area.id}`}>
                            <div className="flex flex-center mb10">
                                <h4 className="" style={{ fontSize: '18px' }}>
                                    {area.name}
                                </h4>
                                <div className="flex-grow mr10 ml10">
                                    <span
                                        className={`no-hover btn btn-xs btn-rating btn-${ratingColour(rating)}`}
                                        title={text.behaviours.card.rating}
                                    >
                                        {rating.toFixed(1)}
                                    </span>
                                </div>
                                {drilldown.area_Id === area.id && (
                                    <button className="btn btn-sm" onClick={() => setDrilldown({})}>
                                        <i className="fa fa-times mr10" />
                                        {drilldown.name}
                                    </button>
                                )}
                            </div>
                            <div className="row behaviour-cards">
                                {drilldown.area_Id === area.id ? (
                                    <div key={`capability-${drilldown.id}`}>
                                        {filtered
                                            .filter(competency => competency.id === drilldown.id)
                                            .map(competency => (
                                                <div key={`competency-${competency.id}`} className="col-sm-6 col-md-4">
                                                    <PerformanceCompetencyCard
                                                        text={text}
                                                        profile={profile}
                                                        competency={competency}
                                                        reloading={reloading}
                                                        onFlag={onFlag}
                                                        show={show}
                                                        basic
                                                    />
                                                </div>
                                            ))}
                                    </div>
                                ) : (
                                    areaCompetenciesFiltered.map(competency => {
                                        return (
                                            <div
                                                key={`competency-${competency.id}`}
                                                className="col-sm-6 col-md-4"
                                                // onClick={e => {
                                                //     if (
                                                //         ![...e.target.classList]?.some(x => ['fa', 'btn'].some(y => y === x))
                                                //     )
                                                //         setDrilldown(competency);
                                                // }}
                                            >
                                                <PerformanceCompetencyCard
                                                    text={text}
                                                    profile={profile}
                                                    competency={{
                                                        ...competency,
                                                        competency_Id: competency.id,
                                                    }}
                                                    reloading={reloading}
                                                    onFlag={onFlag}
                                                    show={show}
                                                    basic
                                                />
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        </div>
                    );
                })
            ) : (
                <NoResults title={text.all.noResults.title} message={text.all.noResults.message} />
            )}
        </div>
    );
};

export default All;
